import { bookingFlowStoreSelector } from '../../../store';

const CALIFORNIA_STATE_CODE = 'CA';

export const useIsCaliforniaPickup = (): boolean => {
  const pickupStateCode = bookingFlowStoreSelector.use.pickupStateCode?.();
  return pickupStateCode?.toUpperCase() === CALIFORNIA_STATE_CODE;
};
